import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ba97cb52")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-mr-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Filter by status", -1)
const _hoisted_4 = { class: "field-checkbox m-0" }
const _hoisted_5 = {
  class: "p-ml-2",
  for: "is_read"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationsFilters = _resolveComponent("NotificationsFilters")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_YesNo = _resolveComponent("YesNo")!
  const _component_TriStateCheckbox = _resolveComponent("TriStateCheckbox")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_AssignNotificationDialog = _resolveComponent("AssignNotificationDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('notification.list.title')), 1)
    ]),
    _createVNode(_component_NotificationsFilters, {
      filters: _ctx.advFilters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters = $event)),
      onChange: _ctx.onFiltersChange
    }, null, 8, ["filters", "onChange"]),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      "striped-rows": false,
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      rowClass: _ctx.rowClass,
      sortField: `created_at`,
      sortOrder: 1,
      onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDetails($event))),
      onResetFilters: _ctx.onReset
    }, {
      actions: _withCtx(({data}) => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-eye",
            disabled: _ctx.requestPending,
            class: "p-button-info",
            onClick: ($event: any) => (_ctx.readNotification(data))
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, {
          field: "created_at",
          header: "Sent At",
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.created_at,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "type",
          header: "Type",
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.types,
              optionLabel: "name",
              optionValue: "code",
              placeholder: "Select a Type"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.$t('notification.list.type_' + data.type)), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "user_owner_name",
          header: "Owner",
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Search by owner name",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createVNode(_component_Button, {
              onClick: ($event: any) => (_ctx.changeOwner(data.id)),
              style: {"vertical-align":"middle"},
              icon: "pi pi-users",
              class: "p-mr-2 p-button-rounded p-button-secondary p-button-text"
            }, null, 8, ["onClick"]),
            _createTextVNode(" " + _toDisplayString(data.user_owner_name), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "status",
          header: "Status",
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _hoisted_3,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statuses,
              placeholder: "Select statuses",
              optionLabel: "name",
              "option-value": "code"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.status,
              "onUpdate:modelValue": ($event: any) => (data.status = $event),
              optionValue: "code",
              onChange: ($event: any) => (_ctx.changeStatus(data)),
              options: _ctx.statuses,
              optionLabel: "name"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "message",
          header: "Message"
        }),
        _createVNode(_component_Column, {
          field: "is_read",
          header: "Read",
          dataType: "boolean",
          bodyClass: "text-center",
          style: {"min-width":"4rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_YesNo, {
              value: data.is_read
            }, null, 8, ["value"])
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_TriStateCheckbox, {
                inputId: "is_read",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                onChange: ($event: any) => (onApplyFilter(filterCallback))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
              _createElementVNode("label", _hoisted_5, _toDisplayString(filterModel.value == null ? 'null' : filterModel.value === true ? _ctx.$t('common.yes') : _ctx.$t('common.no')), 1)
            ])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "is_email_sent",
          header: "Email sent"
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_YesNo, {
              value: data.is_email_sent
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "rowClass", "onResetFilters"]),
    _createVNode(_component_AssignNotificationDialog, {
      notification: _ctx.selectedNotificationId,
      onUpdate: _ctx.actualChangingOwner,
      visible: _ctx.displayNotificationDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayNotificationDialog = $event))
    }, null, 8, ["notification", "onUpdate", "visible"])
  ]))
}